module.exports = __webpack_public_path__ + "img/home-min.762d2dcc.png";